import { render, staticRenderFns } from "./BriqTooltip.vue?vue&type=template&id=335ede29&scoped=true&lang=pug&"
import script from "./BriqTooltip.vue?vue&type=script&lang=js&"
export * from "./BriqTooltip.vue?vue&type=script&lang=js&"
import style0 from "./BriqTooltip.vue?vue&type=style&index=0&id=335ede29&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335ede29",
  null
  
)

export default component.exports